import { createAction } from "typesafe-actions";
import generalConstants from "store/features/general/general.constants";

const { ERROR, DISPLAY_ERROR, RESET_UNHANDLED_ERROR, RESET_API_ERROR, FINISH_FORM_SUBMIT } = generalConstants;

export const riseError = createAction(ERROR)<{ err: object; message?: string }>();

export const displayError = createAction(DISPLAY_ERROR)<{ message: string }>();

export const resetUnhandledError = createAction(RESET_UNHANDLED_ERROR)();

export const resetApiError = createAction(RESET_API_ERROR)();

export const finishFormSubmit = createAction(FINISH_FORM_SUBMIT)();
